import {
  useApiSamplesV1SamplesEvidenceList,
  useApiSamplesV1SamplesRetrieve,
  useApiTradeV1SiteMaterialsRetrieve,
} from '../../client/api/api';
import { getSampleVariantFromMaterial } from '../../utils/materialComponentValue/materialComponentValue';

export const useEvidenceSampleSessionDetails = (sampleId: number, siteMaterialId: number) => {
  const { data: evidenceData, isLoading: isEvidenceLoading } = useApiSamplesV1SamplesEvidenceList(sampleId, undefined, {
    query: {
      enabled: Boolean(sampleId),
    },
  });

  const { data: composition, isLoading: isCompositionLoading } = useApiSamplesV1SamplesRetrieve(sampleId, {
    query: {
      enabled: Boolean(sampleId),
    },
  });

  const { data: siteMaterial, isLoading: isSiteMaterialLoading } = useApiTradeV1SiteMaterialsRetrieve(
    String(siteMaterialId ?? ''),
    {
      query: {
        enabled: Boolean(siteMaterialId),
        retry: 1, // TODO: remove in https://linear.app/safi/issue/CF-3955/[pending-calum]-unify-quality-report-data-api
      },
    }
  );

  const evidence =
    evidenceData?.results
      .filter((evidence) => evidence.file)
      .map((evidence) => ({
        fullResolutionSrc: evidence.file ? evidence.file : '',
        src: evidence.preview ? evidence.preview : '',
      })) || [];

  const material = getSampleVariantFromMaterial(siteMaterial?.material_spec.title);

  return {
    composition,
    evidence,
    isLoading: isEvidenceLoading || isCompositionLoading || isSiteMaterialLoading,
    material,
  };
};
